import React, { MouseEventHandler } from 'react';

import { Heading2, Text, TextLink } from '@lightspeed/flame/Text';

import Format from '../app/src/data/Format';

import { formatCurrency } from '../PurchaseOrder/ShipmentHistory/utils/format';
import { CapitalOffer } from './BusinessSnapshot.types';
import StockoutChart from './StockoutChart';

type Props = {
  offer: CapitalOffer;
  onLearnMore: MouseEventHandler;
  data: any;
  isLoading: boolean;
  isError: boolean;
};

type StockoutPoint = {
  /* eslint-disable camelcase */
  total_missed_revenue: string;
};

export function Stockout({ offer, onLearnMore, data, isLoading, isError }: Props) {
  const missedRevenueData = data?.data?.chartData?.sale_to_missed_revenue ?? [];

  // Sum the total missed revenue
  const totalMissedRevenue = missedRevenueData.reduce(
    (total: number, { total_missed_revenue }: StockoutPoint) => {
      const num = Format.parseInt(total_missed_revenue, 0);
      return total + num;
    },
    0
  );

  const formattedTotalMissedRevenue = formatCurrency(totalMissedRevenue, offer.currency, true);

  return (
    <>
      <Heading2>Get holiday ready with fast funding.</Heading2>
      <Text fontSize="14px" mt={-2} color="#020203">
        Based on your data, we determined that stockouts resulted in <br />a loss of{' '}
        <var>{formattedTotalMissedRevenue}</var> over a nine month period.
      </Text>
      <StockoutChart
        data={data && data?.data?.chartData?.sale_to_missed_revenue}
        isLoading={isLoading}
        isError={isError}
      />
      <Text fontSize="18px">
        Secure up to <span>{formatCurrency(offer.offerAmount, offer.currency, true)}</span> in{' '}
        <TextLink href="#" onClick={onLearnMore}>
          Lightspeed Capital
        </TextLink>{' '}
        to stock up for peak season and seize every holiday sale.
      </Text>
    </>
  );
}
